import { useSelector } from 'react-redux'
import { RootState } from 'slices'


// some additional restrictions
const LNRMAP: {[k: number]: string[]} = {
    410033: ['M_Meldungen', 'M_Meldungen_Katalog', 
        'C_..\\NURIS\\NCREM.NURIS.MELDUNG', 
        'C_..\\NURIS\\NCREM.NURIS.MELDUNGSART', 
        'C_..\\NURIS\\NCREM.NURIS.MELDUNGSTATUSART', 
        'C_..\\NURIS\\NCREM.NURIS.MELDUNGPRIO', 
        'C_..\\NURIS\\NCREM.NURIS.MELDUNGHINWEIS', 
        'C_..\\NURIS\\NCREM.NURIS.MELDUNGHINWEIS3',
        'M_85', 'M_86',
        'C_..\\NURIS\\NCREM.NURIS.AUFTRAG', 
        'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\AUFTRAGSART', 
        'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\AUFTRAGPRIO', 
        'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\AUFTRAGHINWEIS', 
        'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\AUFTRAGSSTATUSART',
        'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\GENEHMIGUNGSDEFINITION',
        'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\LEISTUNGSART',
        'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\LEISTUNGSVERZEICHNIS',
        'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\GWSICHERUNGSART',
        'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\GWSICHERUNGSSTATUS',
        'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\GWMAENGELSTATUS',
        'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\LIEFERBEDINGUNG',
        'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\ZAHLUNGSBEDINGUNG',
        'M_87', 'M_88',
        'C_..\\nuris\\NCrem.Nuris.TO',
        'C_..\\nuris\\NCrem.Nuris.TO\\TODef',
        'C_..\\nuris\\NCrem.Nuris.TO\\TOPruefungsart',
        'C_..\\nuris\\NCrem.Nuris.TO\\TOHersteller',
        'C_..\\nuris\\NCrem.Nuris.TO\\TOGesundheitsamt',
        'C_..\\nuris\\NCrem.Nuris.TO\\TORechtsgrundlagen',
        'M_3', //Stammdaten
        'M_13', // Flächenmanagement
        'C_ix1072',
        'C_ix1071',
        'C_ix1070',
        'M_2', // Buchhaltung
        'C_IX2010',
        'C_DR1000', // Stammdaten-Druck
        'C_lx11722',
        'C_lx11725',
        'C_lx107122'
   ],
   310622: ['M_Meldungen', 'M_Meldungen_Katalog', 
        'C_..\\NURIS\\NCREM.NURIS.MELDUNG', 
        'C_..\\NURIS\\NCREM.NURIS.MELDUNGSART', 
        'C_..\\NURIS\\NCREM.NURIS.MELDUNGSTATUSART', 
        'C_..\\NURIS\\NCREM.NURIS.MELDUNGPRIO', 
        'C_..\\NURIS\\NCREM.NURIS.MELDUNGHINWEIS', 
        'C_..\\NURIS\\NCREM.NURIS.MELDUNGHINWEIS3',
        'M_85', 'M_86',
        'C_..\\NURIS\\NCREM.NURIS.AUFTRAG', 
        'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\AUFTRAGSART', 
       'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\AUFTRAGPRIO', 
       'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\AUFTRAGHINWEIS', 
       'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\AUFTRAGSSTATUSART',
       'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\GENEHMIGUNGSDEFINITION',
       'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\LEISTUNGSART',
       'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\LEISTUNGSVERZEICHNIS',
       'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\GWSICHERUNGSART',
       'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\GWSICHERUNGSSTATUS',
       'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\GWMAENGELSTATUS',
       'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\LIEFERBEDINGUNG',
       'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\ZAHLUNGSBEDINGUNG',
       'M_87', 'M_88',
       'C_..\\nuris\\NCrem.Nuris.TO',
       'C_..\\nuris\\NCrem.Nuris.TO\\TODef',
       'C_..\\nuris\\NCrem.Nuris.TO\\TOPruefungsart',
       'C_..\\nuris\\NCrem.Nuris.TO\\TOHersteller',
       'C_..\\nuris\\NCrem.Nuris.TO\\TOGesundheitsamt',
       'C_..\\nuris\\NCrem.Nuris.TO\\TORechtsgrundlagen'
   ]
}

export const check = (prg: string, rights: any): boolean => {
    let moduleRight = 'X'

    if (prg.startsWith('V_')) {
        moduleRight = rights[prg].right
    } else if (rights && rights.statusAll === 'loaded' && rights.statusLNR === 'loaded') {
        if (rights.LNR && LNRMAP[rights.LNR]) {
            moduleRight = LNRMAP[rights.LNR].map(r => r.toLowerCase()).includes(prg.toLowerCase()) ? ' ' : 'X'
        } else {
            if (prg && rights[prg]) {
                moduleRight = rights[prg].right
            } else {
                moduleRight = ''
            }
        }
    }

    return moduleRight !== 'X'
}


export const Can = ({ yes=() => null, no=() => null, prg }: any) => {
    const rights = useSelector((state: RootState) => state.rights)

    return check(prg, rights)
        ? yes
        : no
}
